import React, { useEffect } from "react";
import { FC } from "react";
import clsx from "clsx";
import { Link, useHistory, useParams } from "react-router-dom";
import "./TruckNominationHeader.css";
import * as ActivityLogStore from "../../store/ActivityLogsStore";
import * as SofViewStore from "../../store/SofViewStore";
import { mergeStyleSets } from "office-ui-fabric-react";
import { SofView } from "../../models";
type IProps = ActivityLogStore.ActivityLogsState &
  SofViewStore.SofViewState &
  typeof SofViewStore.actionCreators;
const deleteActivitiesEnv: string[] = ["-dev", "-uat", "-sandbox", "localhost"];
const classes = mergeStyleSets({
  headerRow: {
    display: "flex",
    alignItems: "center",
    padding: "6px 24px",
    background: "white",
    borderBottom: "1px solid #E2E6E8",
  },
  headerRowTextPane: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    margin: "0 10px",
    paddingLeft: 10,
    borderLeft: "1px solid #E2E6E8",
  },
  headerTitle: {
    color: "#00447E",
    letterSpacing: "0.004em",
    fontSize: 16,
    lineHeight: "20px",
    fontWeight: "bold",
  },
});
export const TruckNominationHeader: FC<IProps> = (props: IProps) => {
  const { lineHandlingNo, nominationNo } = useParams() as any;
  const history = useHistory();
  let url =
    window.location.pathname.indexOf("truck") > 0
      ? "truck"
      : window.location.pathname.indexOf("rail") > 0
      ? "rail"
      : "";
  return (
    <div
      className="btn-menu-group menu-layout-2"
      style={{
        padding: "8px 12px",
        background: "white",
      }}
    >
      <div style={{ display: "flex", gap: "16px", width: "100%" }}>
        <div
          id="btn-toggle-nomination 1"
          className={clsx(
            "btn-menu-v2",
            (props.sofView === SofView.Nomination ||
              props.sofView === SofView.NominationEdit) &&
              "btn-menu-selected-v2"
          )}
          onClick={() => {
            props.setSofView(SofView.Nomination);
            history.push(`/${url}/${lineHandlingNo}/sof`);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <mask
              id="mask0_6_2537"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="25"
              height="24"
            >
              <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6_2537)">
              <path
                d="M4.74039 20.5C4.52789 20.5 4.34978 20.428 4.20604 20.2842C4.06229 20.1404 3.99042 19.9622 3.99042 19.7496C3.99042 19.537 4.06229 19.3589 4.20604 19.2154C4.34978 19.0718 4.52789 19 4.74039 19H5.84617V12.75H4.74039C4.52789 12.75 4.34978 12.6781 4.20604 12.5343C4.06229 12.3904 3.99042 12.2122 3.99042 11.9997C3.99042 11.7871 4.06229 11.609 4.20604 11.4654C4.34978 11.3218 4.52789 11.25 4.74039 11.25H5.84617V4.99998H4.74039C4.52789 4.99998 4.34978 4.92807 4.20604 4.78425C4.06229 4.64045 3.99042 4.46225 3.99042 4.24965C3.99042 4.03707 4.06229 3.85898 4.20604 3.7154C4.34978 3.5718 4.52789 3.5 4.74039 3.5H20.25C20.4625 3.5 20.6406 3.57191 20.7843 3.71573C20.9281 3.85954 21 4.03774 21 4.25033C21 4.46293 20.9281 4.64102 20.7843 4.7846C20.6406 4.92818 20.4625 4.99998 20.25 4.99998H19.1538V11.25H20.25C20.4625 11.25 20.6406 11.3219 20.7843 11.4657C20.9281 11.6095 21 11.7877 21 12.0003C21 12.2129 20.9281 12.391 20.7843 12.5346C20.6406 12.6782 20.4625 12.75 20.25 12.75H19.1538V19H20.25C20.4625 19 20.6406 19.0719 20.7843 19.2157C20.9281 19.3595 21 19.5377 21 19.7503C21 19.9629 20.9281 20.141 20.7843 20.2846C20.6406 20.4282 20.4625 20.5 20.25 20.5H4.74039ZM7.34614 19H17.6538V12.75H17.4038C17.1913 12.75 17.0132 12.6781 16.8695 12.5343C16.7257 12.3904 16.6538 12.2122 16.6538 11.9997C16.6538 11.7871 16.7257 11.609 16.8695 11.4654C17.0132 11.3218 17.1913 11.25 17.4038 11.25H17.6538V4.99998H7.34614V11.25H7.59614C7.80864 11.25 7.98677 11.3219 8.13052 11.4657C8.27427 11.6095 8.34614 11.7877 8.34614 12.0003C8.34614 12.2129 8.27427 12.391 8.13052 12.5346C7.98677 12.6782 7.80864 12.75 7.59614 12.75H7.34614V19ZM12.4989 15.6827C13.2624 15.6827 13.9118 15.4191 14.4471 14.892C14.9823 14.3649 15.25 13.727 15.25 12.9784C15.25 12.3825 15.0781 11.8707 14.7343 11.443C14.3906 11.0152 13.6458 10.1368 12.5 8.8077C11.359 10.1256 10.6154 11.0019 10.2692 11.4366C9.92309 11.8713 9.75002 12.386 9.75002 12.9809C9.75002 13.7282 10.0173 14.3653 10.5518 14.8923C11.0863 15.4192 11.7353 15.6827 12.4989 15.6827Z"
                fill="#1C1B1F"
              />
            </g>
          </svg>
          <div style={{ textTransform: "capitalize", lineHeight: "24px" }}>
            {url} Nominations
          </div>
        </div>
        <div
          onClick={() => {
            props.setSofView(SofView.WorkPacket);
            history.push(
              `/${url}/${lineHandlingNo ?? nominationNo}/work-packets`
            );
          }}
          id="btn-toggle-nomination"
          className={clsx(
            "btn-menu-v2",
            props.sofView === SofView.WorkPacket && "btn-menu-selected-v2"
          )}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <mask
              id="mask0_6_2542"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="24"
              height="24"
            >
              <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6_2542)">
              <path
                d="M10.5808 15.723L17.3038 8.99998L16.25 7.94615L10.5808 13.6154L7.73078 10.7654L6.67696 11.8192L10.5808 15.723ZM5.30773 20.5C4.80901 20.5 4.38306 20.3233 4.02986 19.9701C3.67664 19.6169 3.50003 19.191 3.50003 18.6923V5.3077C3.50003 4.80898 3.67664 4.38302 4.02986 4.02982C4.38306 3.67661 4.80901 3.5 5.30773 3.5H9.75773C9.82055 2.94488 10.0628 2.47278 10.4846 2.08368C10.9064 1.69456 11.4116 1.5 12 1.5C12.5949 1.5 13.1032 1.69456 13.525 2.08368C13.9468 2.47278 14.1859 2.94488 14.2423 3.5H18.6923C19.191 3.5 19.617 3.67661 19.9702 4.02982C20.3234 4.38302 20.5 4.80898 20.5 5.3077V18.6923C20.5 19.191 20.3234 19.6169 19.9702 19.9701C19.617 20.3233 19.191 20.5 18.6923 20.5H5.30773ZM5.30773 19H18.6923C18.7692 19 18.8397 18.9679 18.9039 18.9038C18.968 18.8397 19 18.7692 19 18.6923V5.3077C19 5.23077 18.968 5.16024 18.9039 5.09613C18.8397 5.03203 18.7692 4.99998 18.6923 4.99998H5.30773C5.2308 4.99998 5.16027 5.03203 5.09616 5.09613C5.03206 5.16024 5.00001 5.23077 5.00001 5.3077V18.6923C5.00001 18.7692 5.03206 18.8397 5.09616 18.9038C5.16027 18.9679 5.2308 19 5.30773 19ZM12 4.34613C12.2167 4.34613 12.3958 4.27529 12.5375 4.13363C12.6792 3.99196 12.75 3.81279 12.75 3.59613C12.75 3.37946 12.6792 3.20029 12.5375 3.05863C12.3958 2.91696 12.2167 2.84613 12 2.84613C11.7833 2.84613 11.6042 2.91696 11.4625 3.05863C11.3208 3.20029 11.25 3.37946 11.25 3.59613C11.25 3.81279 11.3208 3.99196 11.4625 4.13363C11.6042 4.27529 11.7833 4.34613 12 4.34613Z"
                fill="#1C1B1F"
              />
            </g>
          </svg>
          <div style={{ textTransform: "capitalize", lineHeight: "24px" }}>
            Work Packet
          </div>
        </div>
        <div
          onClick={() =>
            history.push(`/${url}/${lineHandlingNo ?? nominationNo}/services`)
          }
          id="btn-toggle-nomination"
          className={clsx(
            "btn-menu-v2",
            props.sofView === SofView.AdditionalServices &&
              "btn-menu-selected-v2"
          )}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <mask
              id="mask0_6_2547"
              maskUnits="userSpaceOnUse"
              x="0"
              y="0"
              width="25"
              height="24"
            >
              <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_6_2547)">
              <path
                d="M5.80772 20.5C5.30901 20.5 4.88305 20.3233 4.52985 19.9701C4.17663 19.6169 4.00002 19.191 4.00002 18.6923V5.3077C4.00002 4.80898 4.17663 4.38302 4.52985 4.02982C4.88305 3.67661 5.30901 3.5 5.80772 3.5H10.2577C10.3205 2.94488 10.5628 2.47278 10.9846 2.08368C11.4064 1.69456 11.9115 1.5 12.5 1.5C13.0949 1.5 13.6032 1.69456 14.025 2.08368C14.4468 2.47278 14.6859 2.94488 14.7423 3.5H19.1923C19.691 3.5 20.1169 3.67661 20.4701 4.02982C20.8234 4.38302 21 4.80898 21 5.3077V11.6327C20.7538 11.5275 20.5073 11.4384 20.2605 11.3654C20.0138 11.2923 19.7603 11.234 19.5 11.1904V5.3077C19.5 5.23077 19.4679 5.16024 19.4038 5.09613C19.3397 5.03203 19.2692 4.99998 19.1923 4.99998H5.80772C5.73079 4.99998 5.66026 5.03203 5.59615 5.09613C5.53205 5.16024 5.5 5.23077 5.5 5.3077V18.6923C5.5 18.7692 5.53205 18.8397 5.59615 18.9038C5.66026 18.9679 5.73079 19 5.80772 19H11.6654C11.7026 19.2769 11.7577 19.5387 11.8308 19.7855C11.9038 20.0323 11.9929 20.2705 12.0981 20.5H5.80772ZM5.5 19V4.99998V11.1904V11.1154V19ZM7.75002 16.6346H11.7673C11.8109 16.3743 11.8756 16.1208 11.9615 15.874C12.0474 15.6272 12.141 15.3808 12.2423 15.1346H7.75002V16.6346ZM7.75002 12.75H14.0904C14.5212 12.3846 14.9808 12.0785 15.4692 11.8317C15.9577 11.5849 16.4807 11.4096 17.0384 11.3058V11.25H7.75002V12.75ZM7.75002 8.86535H17.25V7.36538H7.75002V8.86535ZM12.5 4.34613C12.7167 4.34613 12.8958 4.27529 13.0375 4.13363C13.1792 3.99196 13.25 3.81279 13.25 3.59613C13.25 3.37946 13.1792 3.20029 13.0375 3.05863C12.8958 2.91696 12.7167 2.84613 12.5 2.84613C12.2833 2.84613 12.1042 2.91696 11.9625 3.05863C11.8208 3.20029 11.75 3.37946 11.75 3.59613C11.75 3.81279 11.8208 3.99196 11.9625 4.13363C12.1042 4.27529 12.2833 4.34613 12.5 4.34613ZM18.5 22.5576C17.2513 22.5576 16.1891 22.1198 15.3135 21.2442C14.4378 20.3685 14 19.3064 14 18.0577C14 16.809 14.4378 15.7468 15.3135 14.8712C16.1891 13.9955 17.2513 13.5577 18.5 13.5577C19.7487 13.5577 20.8109 13.9955 21.6865 14.8712C22.5622 15.7468 23 16.809 23 18.0577C23 19.3064 22.5622 20.3685 21.6865 21.2442C20.8109 22.1198 19.7487 22.5576 18.5 22.5576ZM18.0577 21H18.9423V18.5H21.4423V17.6154H18.9423V15.1154H18.0577V17.6154H15.5577V18.5H18.0577V21Z"
                fill="#1C1B1F"
              />
            </g>
          </svg>
          <div style={{ textTransform: "capitalize", lineHeight: "24px" }}>
            Services
          </div>
        </div>
      </div>
    </div>
  );
};

export default TruckNominationHeader;
